import React, { useEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import { Container } from "reactstrap";
import styled from "styled-components";
import { connect } from "react-redux";

import { getTrendingProduct, getTopSellingProduct } from "../../../actions/productAction";

import { LuxurySlider, AuthenticateInfo, TableSection, LuxuryHotProducts, LuxuryConcierge, TrendingNowLuxury, LuxuryBrand } from "../Luxury"

import PopularProduct from "../../PageHome/PopularProducts"

import EditorsCarousel from "../EditorsCarousel";

const LuxuryHome = ({ dataTrending, dataTopSelling, getTrendingProduct, getTopSellingProduct, history }) => {
  return (
    <div>
      <LuxurySlider />
      <SpaceSlider />
      <LuxuryBrand history={history} />
      <LuxuryConcierge />
      <LuxuryHotProducts history={history} />
      <TrendingNowLuxury history={history} />
      <SpaceBottom />
      <AuthenticateInfo />
      <SpaceBottom />
      <PopularProduct />
    </div>
  )
}

const SpaceSlider = styled.div`
  height: 80px;
  width: 100%;
`

const SpaceBottom = styled.div`
  height: 40px;
  width: 100%;
`

const mapStateToProps = (state) => ({
  dataTrending: state.dataProduct.trending,
  dataTopSelling: state.dataProduct.topSelling
})

const mapDispatchToProps = {
  getTrendingProduct,
  getTopSellingProduct
}

export default connect(mapStateToProps, mapDispatchToProps)(LuxuryHome);